/**
 * Navegación de página entera fuera del frontal (a `/v1/auth/authorize` o a
 * `puntofirma://`). Aparte para que los tests la sustituyan con `vi.mock`.
 */
export const leaveTo = (url: string) => {
  window.location.assign(url);
};
